export const serviceInfrastructure = [
	// PCI DSS
	{
		name: 'PCI DSS',
		location: 'Инфраструктура: PCI DSS',
		url: '/infrastructure/pci-dss#block1',
	},
	{
		name: 'Соответствие требованиям',
		location: 'Инфраструктура: PCI DSS',
		url: '/infrastructure/pci-dss#block1Title1',
	},
	{
		name: 'Соответствие PCI DSS вместе с CloudPayments',
		location: 'Инфраструктура: PCI DSS',
		url: '/infrastructure/pci-dss#block1Title2',
	},
	{
		name: 'Технология Checkout',
		location: 'Инфраструктура: PCI DSS',
		url: '/infrastructure/pci-dss#block1Title3',
	},
	{
		name: 'ASV-сканирование',
		location: 'Инфраструктура: PCI DSS',
		url: '/infrastructure/pci-dss#block1Title4',
	},
	// Безопасность
	{
		name: 'Безопасность',
		location: 'Инфраструктура: Безопасность',
		url: '/infrastructure/safety#block1',
	},
	{
		name: 'PCI DSS',
		location: 'Инфраструктура: Безопасность',
		url: '/infrastructure/safety#block1Title1',
	},
	{
		name: '3-D Secure',
		location: 'Инфраструктура: Безопасность',
		url: '/infrastructure/safety#block1Title2',
	},
	{
		name: 'Шифрование данных',
		location: 'Инфраструктура: Безопасность',
		url: '/infrastructure/safety#block1Title3',
	},
	// SLA
	{
		name: 'SLA',
		location: 'Инфраструктура: SLA',
		url: '/infrastructure/sla#block1',
	},
	// Дата-центр
	{
		name: 'Дата-центр',
		location: 'Инфраструктура: Дата-центр',
		url: '/infrastructure/data-center#block1',
	},
	{
		name: '2 дата-центра DataLine',
		location: 'Инфраструктура: Дата-центр',
		url: '/infrastructure/data-center#block1Title1',
	},
	{
		name: 'Дата-центр «Миран-1»',
		location: 'Инфраструктура: Дата-центр',
		url: '/infrastructure/data-center#block1Title2',
	},
];
